import { RightImage } from 'components/RightImage.tsx';
import * as React from 'react';
export default {
  RightImage,
  React
};